import axios from "axios";
import { SagaIterator } from "redux-saga";
import { call, cancelled, put, takeLatest } from "redux-saga/effects";

import { callGet } from "../../http_client";
import { createGenerateReportHandler } from "../reports/sagas";

import {
  reportGeneratorTaskCreateRequest,
  retrieveFetchError,
  retrieveFetchRequest,
  retrieveFetchSuccess,
  tableFetchError,
  tableFetchRequest,
  tableFetchSuccess,
} from "./actions";
import { ClicksActionTypes } from "./types";

export function* handleClickTableFetch(action: ReturnType<typeof tableFetchRequest>): SagaIterator {
  const source = axios.CancelToken.source();
  try {
    const { from, to, page, pageSize, market, currency, ordering, gateId } = action.payload;
    const res = yield call(
      callGet,
      "/clicks/",
      { from, to, page, pageSize, market, currency, ordering, gateId },
      source.token
    );
    yield put(tableFetchSuccess(res.data));
  } catch (err) {
    yield put(tableFetchError(err.message));
  } finally {
    if (yield cancelled()) {
      source.cancel();
    }
  }
}

export function* handleClickRetrieveFetch(action: ReturnType<typeof retrieveFetchRequest>): SagaIterator {
  const source = axios.CancelToken.source();
  try {
    const { marker, gateId, currency } = action.payload;
    const response = yield call(callGet, `/clicks/${marker}/`, { gateId, currency }, source.token);
    yield put(retrieveFetchSuccess(response.data));
  } catch (err) {
    yield put(retrieveFetchError(err.message));
  } finally {
    if (yield cancelled()) {
      source.cancel();
    }
  }
}

const handleClicksReportFetch = createGenerateReportHandler<ReturnType<typeof reportGeneratorTaskCreateRequest>>(
  "/clicks/report/"
);

function* watchClicksSagas(): SagaIterator {
  yield takeLatest(ClicksActionTypes.TABLE_FETCH_REQUEST, handleClickTableFetch);
  yield takeLatest(ClicksActionTypes.GENERATE_REPORT_REQUEST, handleClicksReportFetch);
  yield takeLatest(ClicksActionTypes.RETRIEVE_FETCH_REQUEST, handleClickRetrieveFetch);
}

export default watchClicksSagas;
